<template>
  <ContentArea class="col-start-1 col-span-6">
    <div
      v-for="(image, i) in images"
      :key="i"
      class="text-left transition-opacity"
      :class="[
        span,
        {
          'opacity-0': !imageLoaded,
          'center-last-image': i === 2
        }
      ]"
    >
      <CoreImage
        class="w-full"
        :sizes="sizes"
        :image="image.image[0]"
        @load="imageLoaded = true"
      />
      <ContentCaption
        :captionItem="image.captionItem"
        :captionBrand="image.captionBrand"
      />
    </div>
  </ContentArea>
</template>

<script>
import { sizesHelper } from "@c/Core/CoreImage";
import ContentArea from "./ContentArea";
import ContentCaption from "./ContentCaption";

export default {
  name: "ContentImage",

  components: {
    ContentArea,
    ContentCaption
  },

  props: {
    images: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    imageLoaded: false
  }),

  computed: {
    span() {
      switch (this.images.length) {
        case 1:
          return "col-span-6";
        case 2:
          return "col-span-3";
        default:
          return "col-span-3 lg:col-span-2";
      }
    },
    sizes() {
      switch (this.images.length) {
        case 1:
          return sizesHelper([["screen-xl", 1], "100vw"]);
        case 2:
          return sizesHelper([["screen-xl", 2], "50vw"]);
        default:
          return sizesHelper([["screen-xl", 3], "33.33vw"]);
      }
    }
  }
};
</script>

<style scoped>
.center-last-image {
  grid-column: span 6 / span 6;
  width: calc(50% - 0.625rem);
  margin: auto;
}
@screen lg {
  .center-last-image {
    grid-column: span 2 / span 2;
    width: unset;
    margin: unset;
  }
}
</style>
